export default __webpack_public_path__ + "static/media/128x128.232dd027.jpg";